import actions from '../actions/users';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
